import React from "react";
import { Route, Switch, Redirect } from "react-router";

import AuthorizedRouteContainer from "./grundelemente/AuthorizedRouteContainer";
import KopfzeileContainer from "./grundseite/KopfzeileContainer";
import NavizeileContainer from "./grundseite/NavizeileContainer";
import Fusszeile from "./grundseite/Fusszeile";
import UebersichtContainer from "./uebersicht/UebersichtContainer";
import WillkommenLoginContainer from "./willkommen/WillkommenLoginContainer";
import Analysen from "./analysen/AnalysenContainer";
import Energiebilanzierung from "./energiebilanzierung/Energiebilanzierung";
import Wartung from "./wartung/Wartung";
import StoerspeicherContainer from "./stoerspeicher/StoerspeicherContainer";
import Einstellungen from "./einstellungen/Einstellungen";

import "./App.css";

/* Problem: App darf aus irgend einem Grund nicht mit redux-connect()
 * als AppContainer verwendet werden. Ansonsten funktioniert die
 * Navigation gar nicht mehr. An React.Fragment liegt es nicht.
 * Vielleicht wäre die Lösung gewesen, "location" als Property
 * zu übergeben ... vielleicht!?
 */
const App = () => (
	<React.Fragment>
		<div className="App page-wrap">
			<KopfzeileContainer />
			<NavizeileContainer />
			<Switch>
				<Route exact path="/" component={WillkommenLoginContainer} />
				<AuthorizedRouteContainer path="/overview" component={UebersichtContainer} />
				<AuthorizedRouteContainer path="/analysis" component={Analysen} />
				<AuthorizedRouteContainer path="/energy_balancing" component={Energiebilanzierung} />
				<AuthorizedRouteContainer path="/maintenance" component={Wartung} />
				<AuthorizedRouteContainer path="/error_log" component={StoerspeicherContainer} />
				<AuthorizedRouteContainer path="/settings" component={Einstellungen} />
				<Redirect to="/" />
			</Switch>
		</div>
		<Fusszeile />
	</React.Fragment>
);

export default App;
